export default function getProductSummaryFlexibility(
  flexibility: string[] | string | null | undefined,
): string | null | undefined {
  if (Array.isArray(flexibility)) {
    if (flexibility.length > 1) {
      // If there are multiple types, don't display (consistent with getProgramPacing)
      return undefined;
    }
    return flexibility[0];
  }
  return flexibility;
}
